import React from 'react'
import Animated from 'react-native-reanimated'
import type { SharedValue } from 'react-native-reanimated'

// Generic wrapper: only render Animated.View when animatedSharedValues exists
export type AnimatedSharedValues = { opacity?: SharedValue<number>; translateY?: SharedValue<number> }

export const AnimatedWrapper: React.FC<{
  animatedSharedValues?: AnimatedSharedValues
  children: React.ReactNode
  testID?: string
}> = ({ animatedSharedValues, children, testID }) => {
  if (animatedSharedValues) {
    return (
      <Animated.View
        testID={testID}
        style={{
          opacity: animatedSharedValues.opacity || 1,
          transform: [{ translateY: animatedSharedValues.translateY || 0 }],
        }}
      >
        {children}
      </Animated.View>
    )
  }
  return <>{children}</>
}
